import { render, staticRenderFns } from "./agree-dialog.vue?vue&type=template&id=4638ede1&scoped=true"
import script from "./agree-dialog.vue?vue&type=script&lang=js"
export * from "./agree-dialog.vue?vue&type=script&lang=js"
import style0 from "./agree-dialog.vue?vue&type=style&index=0&id=4638ede1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4638ede1",
  null
  
)

export default component.exports